import type { utils } from 'blockly/core';

import { categoryCssConfig, categorySubCssConfig } from '../categoryCssConfig.js';
import { BEGINNER_DISPLAY_COLOR } from './constants.js';

type ToolboxItemInfo = utils.toolbox.ToolboxItemInfo;

function textShadow(text = 'Hello'): Record<string, unknown> {
  return {
    shadow: {
      type: 'text',
      fields: { TEXT: text },
    },
  };
}

/** Beginner Display category — LCD, OLED, and TFT subcategories. */
export function buildBeginnerDisplayCategory(): ToolboxItemInfo {
  return {
    kind: 'category',
    name: 'Display',
    colour: String(BEGINNER_DISPLAY_COLOR),
    cssconfig: categoryCssConfig('display'),
    contents: [
      {
        kind: 'category',
        name: 'LCD Display',
        colour: String(BEGINNER_DISPLAY_COLOR),
        cssconfig: categorySubCssConfig('lcd'),
        contents: [
          { kind: 'block', type: 'beginner_lcd_configure' },
          {
            kind: 'block',
            type: 'beginner_lcd_display_text',
            inputs: { TEXT: textShadow() },
          },
          { kind: 'block', type: 'beginner_lcd_clear' },
          { kind: 'block', type: 'beginner_lcd_set_cursor' },
          { kind: 'block', type: 'beginner_lcd_scroll_left' },
          { kind: 'block', type: 'beginner_lcd_scroll_right' },
        ],
      },
      {
        kind: 'category',
        name: 'OLED Display',
        colour: String(BEGINNER_DISPLAY_COLOR),
        cssconfig: categorySubCssConfig('oled'),
        contents: [
          { kind: 'block', type: 'beginner_oled_configure' },
          { kind: 'block', type: 'beginner_oled_clear' },
          {
            kind: 'block',
            type: 'beginner_oled_display_text',
            inputs: { TEXT: textShadow() },
          },
          { kind: 'block', type: 'beginner_oled_set_text_size' },
          { kind: 'block', type: 'beginner_oled_set_cursor' },
          { kind: 'block', type: 'beginner_oled_draw_pixel' },
          { kind: 'block', type: 'beginner_oled_draw_line' },
          { kind: 'block', type: 'beginner_oled_draw_rectangle' },
          { kind: 'block', type: 'beginner_oled_fill_rectangle' },
          { kind: 'block', type: 'beginner_oled_draw_circle' },
          { kind: 'block', type: 'beginner_oled_fill_circle' },
          { kind: 'block', type: 'beginner_oled_draw_triangle' },
          { kind: 'block', type: 'beginner_oled_fill_screen' },
          { kind: 'block', type: 'beginner_oled_refresh' },
        ],
      },
      {
        kind: 'category',
        name: 'TFT Display',
        colour: String(BEGINNER_DISPLAY_COLOR),
        cssconfig: categorySubCssConfig('tft'),
        contents: [
          { kind: 'block', type: 'beginner_tft_configure' },
          { kind: 'block', type: 'beginner_tft_clear' },
          { kind: 'block', type: 'beginner_tft_fill_screen' },
          {
            kind: 'block',
            type: 'beginner_tft_display_text',
            inputs: { TEXT: textShadow() },
          },
          { kind: 'block', type: 'beginner_tft_set_cursor' },
          { kind: 'block', type: 'beginner_tft_set_text_size' },
          { kind: 'block', type: 'beginner_tft_set_text_color' },
          { kind: 'block', type: 'beginner_tft_draw_pixel' },
          { kind: 'block', type: 'beginner_tft_draw_line' },
          { kind: 'block', type: 'beginner_tft_draw_rectangle' },
          { kind: 'block', type: 'beginner_tft_fill_rectangle' },
          { kind: 'block', type: 'beginner_tft_draw_circle' },
          { kind: 'block', type: 'beginner_tft_fill_circle' },
          { kind: 'block', type: 'beginner_tft_draw_triangle' },
          { kind: 'block', type: 'beginner_tft_fill_triangle' },
          { kind: 'block', type: 'beginner_tft_draw_rounded_rectangle' },
          { kind: 'block', type: 'beginner_tft_fill_rounded_rectangle' },
        ],
      },
    ],
  };
}
